/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConditionCustomFromJSON, ApiConditionCustomToJSON, } from './ApiConditionCustom';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
export function ApiLeadStatusRuleConditionPayloadFromJSON(json) {
    return ApiLeadStatusRuleConditionPayloadFromJSONTyped(json, false);
}
export function ApiLeadStatusRuleConditionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'custom': !exists(json, 'custom') ? undefined : ApiConditionCustomFromJSON(json['custom']),
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiLeadStatusRuleConditionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conversionId': value.conversionId,
        'custom': ApiConditionCustomToJSON(value.custom),
        'operator': ApiOperatorToJSON(value.operator),
        'value': value.value,
    };
}
